import PropTypes from 'prop-types';
import React from 'react';
import Label from './Label';
import Date from '../../../../common/date';
import * as shapes from '../../../../common/shapes';
import Switch from '../../../../common/Switch';

const Header = ({ fromDate, toDate, lastTransferDate, toggleAutoDeposit, autoDepositChecked }) => (
  <div className="c-form-input-group u-mb">
    <div className="c-form-input-group__item">
      <Label>Starting date:</Label>
      <div className="c-btn c-btn--outline c-btn--outline-grey u-border-radius is-disabled u-1/1">
        <Date>{fromDate}</Date>
      </div>
    </div>
    <div className="c-form-input-group__item">
      <Label>Ending date:</Label>
      <div className="c-btn c-btn--outline c-btn--outline-grey u-border-radius is-disabled u-1/1">
        <Date>{toDate}</Date>
      </div>
    </div>
    <div className="c-form-input-group__item">
      <Label>Last Transfer Date</Label>
      <div className="c-btn c-btn--outline c-btn--outline-grey u-border-radius is-disabled u-1/1">
        <Date>{lastTransferDate}</Date>
      </div>
    </div>
    <div className="c-form-input-group__item u-pt- u-pl- u-mt--">
      <Switch checked={autoDepositChecked} onChange={toggleAutoDeposit} label="Auto deposit" />
    </div>
  </div>
);
Header.propTypes = {
  fromDate: shapes.date,
  toDate: shapes.date,
  lastTransferDate: shapes.date,
  toggleAutoDeposit: PropTypes.func.isRequired,
  autoDepositChecked: PropTypes.bool.isRequired,
};
Header.defaultProps = {
  fromDate: '',
  toDate: '',
  lastTransferDate: '',
};

export default Header;
